import React, { useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormHelperText from '@mui/material/FormHelperText';

import { handleApiRequest } from '../../../api';
import useApiError from '../../../hook/useApiError';
import { TextFieldWhite, SpanError } from '../../../components/customStyles/form';
import Proccess from '../../../components/loading/Proccess';

import { GENERATION_FORM_ERROR_MSG } from '../constants';

import { FormTitle } from './generationFormStyle';


const ObjectiveType = ({ generationForm, inputErrorMsg, handleInput }) => {
  const { handleApiErrorStatus } = useApiError();
  const [objectiveTypeList, setObjectiveTypeList] = useState([]);
  const [objectiveTypeProgress, setObjectiveTypeProgress] = useState(true);

  const getObjectiveTypeList = () => {
    setObjectiveTypeProgress(true);

    handleApiRequest('getObjectiveTypeList', null)
      .then(res => {
        if (res.status === 200) {
          const resultData = res.data.result;
          setObjectiveTypeList(resultData);
          setObjectiveTypeProgress(false);
        } else {
          handleApiErrorStatus(res);
        }
      })
  }

  useEffect(() => {
    getObjectiveTypeList();
  }, [])

  return (
    <Box mb={5}>
      <FormTitle variant='h4'>文案類型<SpanError>*</SpanError></FormTitle>
      {objectiveTypeProgress ? (
        <Proccess size="medium" />
      ) : (
        <RadioGroup
          name="generation_text_objective_type"
          value={generationForm.generation_text_objective_type || ""}
          onChange={handleInput}
        >
          <Grid mt={2} container columns={2} spacing={1}
            sx={{
              '& .MuiGrid-item': {
                paddingY: 0
              }
            }}
          >
            {objectiveTypeList.map((obj, index) => (
              <Grid item xs={1} key={obj.objective_type} sx={{ padding: 0 }}>
                <FormControlLabel
                  value={obj.objective_type}
                  control={<Radio />}
                  label={obj.objective_type_display_name}
                />
                {obj.objective_type === 'CUSTOM' &&
                  generationForm.generation_text_objective_type === 'CUSTOM' &&
                  <>
                    <TextFieldWhite
                      name="generation_text_objective_custom"
                      placeholder="輸入自定義文案類型／生成目標"
                      value={generationForm.generation_text_objective_custom || ""}
                      onChange={handleInput}
                    // error={inputErrorMsg?.objectiveCustom || false}
                    />
                    {inputErrorMsg?.objectiveCustom &&
                      <FormHelperText error>{GENERATION_FORM_ERROR_MSG.objectiveCustom}</FormHelperText>
                    }
                  </>
                }
              </Grid>
            ))}
          </Grid>
        </RadioGroup>
      )}
      {inputErrorMsg?.objectiveType &&
        <FormHelperText error>{GENERATION_FORM_ERROR_MSG.objectiveType}</FormHelperText>
      }
    </Box>
  )
}

export default ObjectiveType;